import React, { PureComponent } from 'react';
import * as yup from 'yup';
require('yup-password')(yup) // extend yup

const passwordSetup = (requiredMessage = 'Password is required') => {
    return yup
        .string()
        .password()
        .min(8, <p>Password must be at least 8 characters</p>)
        .minLowercase(1, <p>Password must contain at least 1 lowercase letter</p>)
        .minUppercase(1, <p>Password must contain at least 1 uppercase letter</p>)
        .minNumbers(1, <p>Password must contain at least 1 number</p>)
        .minSymbols(1, <p>Password must contain at least 1 symbol</p>)
        .required(requiredMessage)
}

export default passwordSetup;